import { useState } from 'react';

/**
 * Per-device "Show Key findings" preference. Gates the Key findings card at
 * the top of the patient Summary feed. OFF by default; toggled on Profile.
 *
 * Mirrors `useShowSummaryStats` deliberately — same storage shape, same
 * read-on-mount, same default. The two sit next to each other on Profile and
 * behaving differently would be the surprise.
 */
const STORAGE_KEY = 'ui.showKeyFindings';

export const readShowKeyFindings = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const useShowKeyFindings = (): [boolean, (next: boolean) => void] => {
  const [value, setValue] = useState<boolean>(readShowKeyFindings);
  const set = (next: boolean) => {
    setValue(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
      /* private mode / quota — ignore */
    }
  };
  return [value, set];
};
